import MuiCallSplitIcon from "@mui/icons-material/CallSplit";
import type { TypographyProps } from "@mui/material";
import { Typography, Toolbar as UnstyledToolbar, styled } from "@mui/material";
import { Link } from "react-router";

import { CatalystExpanded } from "#src/components/catalyst/catalyst.sx";

export const Toolbar = styled(UnstyledToolbar)(({ theme }) => ({
  backgroundColor: theme.palette.common.black,
  height: theme.spacing(theme.layout.PROJECT_TOOLBAR_HEIGHT),
  transition: theme.transitions.create("margin"),

  "@media (min-width: 0px)": {
    // increase specificity
    padding: 0,
  },

  [`@media (min-width: ${theme.spacing(
    theme.layout.CATALYST_WIDTH + theme.layout.SCREEN_BREAK_1,
  )})`]: {
    [`${CatalystExpanded} ~ header &`]: {
      marginLeft: theme.spacing(theme.layout.CATALYST_WIDTH),
    },
  },
}));

export const HeaderLink = styled(Link)(({ theme }) => ({
  color: "inherit",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
  padding: theme.spacing(0, 5),
  textDecoration: "none",
}));

export const Description = styled("div")({
  display: "flex",
  opacity: 0.6,
});

export const MainHeader = styled(Typography)<TypographyProps>(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(0.5),
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const Container = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.grey[800],
  color: "inherit",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  maxWidth: "50%",
  minWidth: theme.spacing(60),
  position: "relative",
  "::after": {
    aspectRatio: "1 / 2",
    backgroundColor: theme.palette.grey[800],
    clipPath: "polygon(0 0, 100% 0, 0 100%)",
    content: "''",
    height: "100%",
    left: "100%",
    position: "absolute",
    zIndex: 1,
  },
}));

const Text = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  // keep the text above the skew
  zIndex: 2,
});

export const Title = styled(Text)<TypographyProps>(({ theme }) => ({
  fontSize: theme.typography.fontSizeXl,
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: "1px",
}));

export const DescriptionPrefix = styled("span")({
  textTransform: "uppercase",
});

export const DescriptionText = styled(Text)(({ theme }) => ({
  fontSize: theme.typography.fontSizeMd,
}));

export const CallSplitIcon = styled(MuiCallSplitIcon)({
  transform: "rotate(180deg)",
});
